export function Search() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentcolor"
    >
      <path d="M23.4516 20.7984L17.8406 15.1875C19.1166 13.2933 19.7461 10.9266 19.4091 8.40469C18.8344 4.11516 15.3188 0.624374 11.025 0.0807647C4.6411 -0.727032 -0.727024 4.64109 0.0808194 11.025C0.624569 15.3206 4.11582 18.8391 8.40582 19.4109C10.9277 19.7479 13.2949 19.1186 15.1886 17.8425L20.7996 23.4534C21.5318 24.1856 22.7191 24.1856 23.4513 23.4534C24.1828 22.7203 24.1828 21.5297 23.4516 20.7984ZM3.70782 9.75C3.70782 6.44156 6.39938 3.75 9.70782 3.75C13.0163 3.75 15.7078 6.44156 15.7078 9.75C15.7078 13.0584 13.0163 15.75 9.70782 15.75C6.39938 15.75 3.70782 13.0594 3.70782 9.75Z" />
    </svg>
  );
}
